package org.catharsis.spendtel.feature.presentation.home

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontWeight
import org.catharsis.spendtel.feature.data.ExpenseReport

@Composable
fun DeleteExpenseReportDialog(
    report: ExpenseReport,
    isDeleting: Boolean,
    onDismiss: () -> Unit,
    onConfirmDelete: () -> Unit,
) {
    AlertDialog(
        onDismissRequest = {
            if (!isDeleting) onDismiss()
        },
        title = {
            Text(
                text = "Delete report?",
                fontWeight = FontWeight.SemiBold,
            )
        },
        text = {
            Text(
                text = "This will permanently remove \"${report.displayLabel}\" and its analysis from your account.",
                style = MaterialTheme.typography.bodyMedium,
            )
        },
        confirmButton = {
            TextButton(
                onClick = onConfirmDelete,
                enabled = !isDeleting,
            ) {
                Text(if (isDeleting) "Deleting…" else "Delete")
            }
        },
        dismissButton = {
            TextButton(
                onClick = onDismiss,
                enabled = !isDeleting,
            ) {
                Text("Cancel")
            }
        },
    )
}
